@if (allowTransform) {
    <div
        class="img-container"
        [class.-sh-fullscreen]="fullscreen"
        (wheel)="scrollZoom($event)"
        (mousedown)="onDragStart($event)"
        (mouseup)="onDragEnd($event)"
        (mouseleave)="onDragEnd($event)"
        (mousemove)="onDragOver($event)"
        (mouseover)="loadFaceFrames()"
        (mouseleave)="hideFaceFrames()"
    >
        <img
            #image
            [class.sh-visually-hidden]="loading"
            [class.draggable]="draggable && !dragging"
            [class.dragging]="draggable && dragging"
            [class.transition]="transition"
            [class.-sh-fullscreen]="fullscreen"
            [src]="_imageSources[index]"
            [ngStyle]="style"
            draggable="false"
            alt="Image not accessible..."
            (load)="onLoad(_imageSources[index])"
            (error)="imageNotFound(_imageSources[index])"
            (loadstart)="onLoadStart(_imageSources[index])"
        />

        @if (loading) {
            <div class="spinner-container">
                <svg sh-icon class="-sh-spin" [name]="'spinner'" aria-hidden="true"></svg>
            </div>
        }

        <ng-container *ngTemplateOutlet="faceFramesContainer"></ng-container>

        @if (_imageSources.length > 1) {
            <div class="nav-button-container">
                <button
                    type="button"
                    class="sh-pure-icon-button -sh-raised"
                    [title]="viewerTranslations.previous"
                    (click)="prevImage($event)"
                    [disabled]="index === 0"
                >
                    <svg sh-icon [name]="'arrow-left'" aria-hidden="true"></svg>
                </button>
                <button
                    type="button"
                    class="sh-pure-icon-button -sh-raised"
                    [title]="viewerTranslations.next"
                    (click)="nextImage($event)"
                    [disabled]="index === _imageSources.length - 1"
                >
                    <svg sh-icon [name]="'arrow-right'" aria-hidden="true"></svg>
                </button>
            </div>
        }
    </div>
} @else {
    <div class="img-container">
        <img
            #image
            [class.sh-visually-hidden]="loading"
            [class.-sh-fullscreen]="fullscreen"
            [src]="_imageSources[index]"
            [ngStyle]="style"
            draggable="false"
            alt="Image not accessible..."
            (load)="onLoad(_imageSources[index])"
            (error)="imageNotFound(_imageSources[index])"
            (loadstart)="onLoadStart(_imageSources[index])"
            (mouseover)="loadFaceFrames()"
            (mouseleave)="hideFaceFrames()"
        />
        <ng-container *ngTemplateOutlet="faceFramesContainer"></ng-container>
    </div>
}

@if (allowTransform && actionsPosition !== ViewerActionsPosition.BOTTOM_EXTERNAL) {
    <div class="viewer-action-container--vertical">
        @for (item of imageActionButtons; track item) {
            <button type="button" class="sh-pure-icon-button -sh-raised" [ngClass]="actionsPosition" [title]="item.label" (click)="$any(item).eventListener()">
                <svg sh-icon [name]="item.icon" aria-hidden="true"></svg>
            </button>
        }
    </div>
}

@if (allowTransform && actionsPosition === ViewerActionsPosition.BOTTOM_EXTERNAL) {
    <div class="viewer-action-container">
        @for (item of imageActionButtons; track item) {
            <button type="button" class="sh-pure-icon-button -sh-raised" [ngClass]="actionsPosition" [title]="item.label" (click)="$any(item).eventListener()">
                <svg sh-icon [name]="item.icon" aria-hidden="true"></svg>
            </button>
        }
    </div>
}

<ng-template #faceFramesContainer>
    @for (frame of $faceFrames(); track frame.id) {
        @if (fullscreen && frame.personId) {
            <a
                class="face-frame fade-in sh-link"
                [style.left.px]="frame.x"
                [style.top.px]="frame.y"
                [style.width.px]="frame.width"
                [style.height.px]="frame.height"
                [style.display]="showFaceFrames || $focusedFaceId() === frame.id || $hoveredFaceId() === frame.id ? 'block' : 'none'"
                [class.highlight]="$focusedFaceId() === frame.id"
                [title]="frame.name ?? ''"
                (mousedown)="disableDrag($event)"
                [routerLink]="faceUrlLink"
                [queryParams]="getFaceParams(frame)"
            >
                @if (frame.name) {
                    <span class="face-label" [title]="frame.name">{{ frame.name }}</span>
                }
            </a>
        } @else {
            <div
                class="face-frame fade-in"
                [style.cursor]="fullscreen ? 'default' : 'pointer'"
                [style.left.px]="frame.x"
                [style.top.px]="frame.y"
                [style.width.px]="frame.width"
                [style.height.px]="frame.height"
                [style.display]="showFaceFrames || $focusedFaceId() === frame.id || $hoveredFaceId() === frame.id ? 'block' : 'none'"
                [class.highlight]="$focusedFaceId() === frame.id"
                [title]="frame.name ?? ''"
                (mousedown)="disableDrag($event)"
                (click)="onFaceFrameClick($event, frame)"
            >
                @if (frame.name) {
                    <span class="face-label" [title]="frame.name">{{ frame.name }}</span>
                }
            </div>
        }
    }
</ng-template>
